import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { getRGBA } from 'utils/color'

interface ChipStatusProps {
  text: string
  color?: 'failed' | 'success' | 'processing' | 'waiting'
}

const styles = makeStyles(() => ({
  chip: {
    padding: '0.25rem 0.75rem',
    borderRadius: '0.75rem',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    width: 'fit-content',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  chipFailed: {
    color: '#BA1A1A !important',
    backgroundColor: `${getRGBA('#BA1A1A', 0.08)} !important`,
  },

  chipSuccess: {
    color: '#2E7D32 !important',
    backgroundColor: `${getRGBA('#2E7D32', 0.08)} !important`,
    opacity: 1,
  },

  chipProcessing: {
    color: '#3024E1',
    backgroundColor: '#EAE9FC',
  },

  chipWaiting: {
    color: '#191C1A !important',
    backgroundColor: `${getRGBA('#BDBDBD', 0.4)} !important`,
    display: 'flex',
    alignItems: 'center',
    opacity: 0.38,
  },
}))

const ChipText: React.FC<ChipStatusProps> = ({ text, color }) => {
  const classes = styles()

  let actualClasse = null

  if (color === 'failed') {
    actualClasse = classes.chipFailed
  } else if (color === 'processing') {
    actualClasse = classes.chipProcessing
  } else if (color === 'success') {
    actualClasse = classes.chipSuccess
  } else {
    actualClasse = classes.chipWaiting
  }

  return <span className={clsx(classes.chip, actualClasse)}>{text}</span>
}

export default ChipText
